
import Vue from "vue";
export default Vue.extend({
  props: {
    texto: String,
  },
});
